var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareOff(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "0 -960 960 960",
    width: 20,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M696-696q20.4 0 34.2-13.8Q744-723.6 744-744q0-20.4-13.8-34.2Q716.4-792 696-792q-20.4 0-34.2 13.8Q648-764.4 648-744q0 20.4 13.8 34.2Q675.6-696 696-696Zm0 528q20.4 0 34.2-13.8Q744-195.6 744-216q0-20.4-13.8-34.2Q716.4-264 696-264q-20.4 0-34.2 13.8Q648-236.4 648-216q0 20.4 13.8 34.2Q675.6-168 696-168Zm0-576Zm0 528ZM239.774-48Q160-48 104-104.226t-56-136Q48-320 104.226-376t136-56Q320-432 376-375.774t56 136Q432-160 375.774-104t-136 56ZM144-486q2-48 37-81t83-33q22.292 0 42.646 7.5T342-570l238-145q-2-8-3-14.5t-1-14.5q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35q-22.292 0-42.646-7T618-654L380-509q3 17 3.5 25.5T382-462q-31-20-67.196-31-36.195-11-74.804-11-26 0-49.5 4.5T144-486ZM696-96q-50 0-85-35t-35-85q0-8 1-14.5t3-14.5l-82-50q-8-35-23.5-65.5T436-417l182 111q15-17 35.354-23.5T696-336q50 0 85 35t35 85q0 50-35 85t-85 35ZM239-212l56 56 29-29-56-56 56-56-29-29-56 56-56-56-29 29 56 56-56 56 29 29 56-56Z"
  })));
}
export default SvgShareOff;